import { render, staticRenderFns } from "./CommentaryTrendlineTab.vue?vue&type=template&id=abb3c776&scoped=true"
import script from "./CommentaryTrendlineTab.vue?vue&type=script&lang=js"
export * from "./CommentaryTrendlineTab.vue?vue&type=script&lang=js"
import style0 from "./CommentaryTrendlineTab.vue?vue&type=style&index=0&id=abb3c776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb3c776",
  null
  
)

export default component.exports